(function() {
  angular.module("app", ["ngMap", "ngSanitize"]);
})();
